// Company-scoped connected data: labor/rate evidence (C1.1-07) and Vehicle
// holdings (C1.1-06), read via react-query rather than a direct useEffect +
// deliveryClient call. Deliberately NOT added to the shared ./hooks.ts — Lane
// D owns the rate hooks there and a separate ticket is already editing it.
//
// Every query here is keyed by companyProfileId ONLY: evidence and holdings
// follow the profile that earned them. A predecessor's, parent's or JV
// partner's rows never leak in through lineage (C1.1-04/C1.1-08) — a
// relationship connects separate identities, it does not merge their facts.
import { useQuery } from '@tanstack/react-query';
import { deliveryClient } from '../../../lib/connect/clients';
export function useCompanyLaborEntries(tenantId, profileId) {
    return useQuery({
        queryKey: [
            'company evidence',
            'labor',
            profileId
        ],
        enabled: Boolean(profileId),
        queryFn: async ()=>{
            const resp = await deliveryClient.listLaborCategoryEntries({
                companyId: tenantId,
                companyProfileId: profileId,
                search: '',
                contractVehicleId: ''
            });
            return resp.entries;
        }
    });
}
export function useCompanyRateObservations(tenantId, profileId) {
    return useQuery({
        queryKey: [
            'company evidence',
            'rates',
            profileId
        ],
        enabled: Boolean(profileId),
        queryFn: async ()=>{
            const resp = await deliveryClient.listRateObservations({
                companyId: tenantId,
                companyProfileId: profileId,
                lcatEntryId: '',
                contractVehicleId: '',
                observationType: '',
                acrossVersions: false,
                includeCorrected: false,
                limit: 50
            });
            return resp.observations;
        }
    });
}
// C1.1-06: formal, verified Company-Vehicle relationships. C1.4/SAD-435 owns
// the maintenance UI; this is read-only.
export function useCompanyVehicleHoldings(tenantId, profileId) {
    return useQuery({
        queryKey: [
            'company evidence',
            'vehicle holdings',
            profileId
        ],
        enabled: Boolean(profileId),
        queryFn: async ()=>{
            const resp = await deliveryClient.listCompanyVehicleHoldings({
                companyId: tenantId,
                companyProfileId: profileId
            });
            return resp.holdings;
        }
    });
}
